import React, { useState, useContext } from "react";
import {
  AppBar,
  Toolbar,
  IconButton,
  Menu,
  MenuItem,
  Fab,
  NativeSelect,
  // Link
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  Search as SearchIcon,
  Send as SendIcon,
} from "@material-ui/icons";
// import SettingsOutlinedIcon from "@material-ui/icons/SettingsOutlined";

import Autosuggest from "react-autosuggest";
import "../AutoSuggest/AutoSuggest.css";
import { Link } from "react-router-dom";
import useResources from "../../services/listing.service";
import { createMuiTheme, ThemeProvider } from "@material-ui/core/styles";
import classNames from "classnames";
// styles
import useStyles from "./styles";
// components
import { Typography } from "../Wrappers/Wrappers";
import UserAvatar from "../UserAvatar/UserAvatar";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
// context
import {
  useLayoutState,
  useLayoutDispatch,
  toggleSidebar,
} from "../../context/LayoutContext";
import { useUserDispatch, signOut } from "../../context/UserContext";
import { SearchContext } from "../../context/SearchContext";
import PermIdentityOutlinedIcon from "@material-ui/icons/PermIdentityOutlined";
import ExitToAppOutlinedIcon from "@material-ui/icons/ExitToAppOutlined";
import { hasPermission } from "../../services/hasPermission";
import { InputLabel } from "pages/policyView/widgets/InputLabel";
const messages = [
  {
    id: 0,
    variant: "warning",
    name: "Jane Hew",
    message: "Hey! How is it going?",
    time: "9:32",
  },
  {
    id: 1,
    variant: "success",
    name: "Lloyd Brown",
    message: "Check out my new Dashboard",
    time: "9:18",
  },
  {
    id: 2,
    variant: "primary",
    name: "Mark Winstein",
    message: "I want rearrange the appointment",
    time: "9:15",
  },
  {
    id: 3,
    variant: "secondary",
    name: "Liana Dutti",
    message: "Good news from sale department",
    time: "9:09",
  },
];

const notifications = [
  {
    id: 0,
    time: "2.22 pm",
    critical: "Critical",
    title: "Policy DPFL0042780 ",
    color: "warning",
    message:
      "Lorem ipsum dolor sit amet consectetur adipiscing elit.Nea mores quidem sanctos a sapiente",
  },
  {
    id: 1,
    title: "Title 1",
    critical: "Critical",
    time: "9.10 pm",
    color: "success",
    type: "info",
    message: `Lorem ipsum dolor sit amet consectetur adipiscing elit.
    Nea mores quidem sanctos a sapiente`,
  },
  {
    id: 2,
    title: "Title 2",
    time: "yesterday",
    color: "secondary",
    type: "notification",
    message: `Lorem ipsum dolor sit amet consectetur adipiscing elit.
    Nea mores quidem sanctos a sapiente`,
  },
  {
    id: 3,
    time: "yesterday",
    title: "Title 3",
    color: "primary",
    type: "e-commerce",
    message: `Lorem ipsum dolor sit amet consectetur adipiscing elit.
    Nea mores quidem sanctos a sapiente`,
  },
  {
    id: 4,
    title: "Title 4",
    time: "04/20/2020",
    color: "primary",
    type: "e-commerce",
    message: `Lorem ipsum dolor sit amet consectetur adipiscing elit.
    Nea mores quidem sanctos a sapiente`,
  },
  {
    id: 5,
    title: "Title 5",
    time: "04/20/2020",
    color: "primary",
    type: "e-commerce",
    message: `Lorem ipsum dolor sit amet consectetur adipiscing elit.
    Nea mores quidem sanctos a sapiente`,
  },
  {
    id: 6,
    title: "Title 6",
    time: "04/31/2020",
    color: "primary",
    type: "e-commerce",
    message: `Lorem ipsum dolor sit amet consectetur adipiscing elit.
    Nea mores quidem sanctos a sapiente`,
  },
];

const searchOptions = [
  {
    id: 1,
    url: "get/policy/page/csr",
    value: "policyNo",
    label: "Policy No.",
  },
  {
    id: 2,
    url: "get/policy/page/csr",
    value: "insuredName",
    label: "Insured Name",
  },
  {
    id: 3,
    url: "get/policy/driver/details",
    value: "licenseNo",
    label: "License No.",
  },
  {
    id: 4,
    url: "get/policy/car/details",
    value: "vin",
    label: "Car VIN",
  },
  {
    id: 5,
    url: "get/policy/page/csr",
    value: "phoneNo",
    label: "Phone No.",
  },
];
const claimsOptions = [
  {
    id: 7,
    url: "claim/csr",
    value: "claimantName",
    label: "Claimant Name",
  },
  {
    id: 8,
    url: "claim/csr",
    value: "policyNo",
    label: "Policy No.",
  },
  {
    id: 9,
    url: "claim/csr",
    value: "claimNo",
    label: "Claim No.",
  },
];
const renderSuggestion = (suggestion) => (
  <Link className={"suggestion-fields"} to={"/app/search-results"}>
    {suggestion.name}
  </Link>
);

export default function Header(props) {
  var classes = useStyles();
  const companyName = "TITAN";
  // global
  var layoutState = useLayoutState();
  var layoutDispatch = useLayoutDispatch();
  var userDispatch = useUserDispatch();
  // local
  var [mailMenu, setMailMenu] = useState(null);
  var [notificationsMenu, setNotificationsMenu] = useState(null);
  var [profileMenu, setProfileMenu] = useState(null);
  var [bgFlag, setBgFlag] = useState(false);
  var [url, setUrl] = useState(
    localStorage.getItem("URL") ? localStorage.getItem("URL") : "claim/csr",
  );
  const [searchParameter, setSearchParameter] = useState(
    localStorage.getItem("searchElement")
      ? localStorage.getItem("searchElement")
      : "policyNo",
  );
  const [valueDropDown, setValueDropDown] = useState(
    localStorage.getItem("defaultValue")
      ? localStorage.getItem("defaultValue")
      : "policyNo-get/policy/page/csr",
  );
  const [value, setValue] = useContext(SearchContext);
  // const [value, setValue] = useState(props.location.pathname.split("/")[3] ? props.location.pathname.split("/")[3] : "DPFL0");
  const [data, count, isLoading] = useResources(
    url,
    0,
    5,
    "policyNo",
    "ASC",
    searchParameter,
    value,
    [],
    true,
    "",
  );
  const getSuggestionValue = (suggestion) => {
    setValue(suggestion.name);
    return suggestion.name;
  };

  const onChange = (event, { newValue }) => {
    if (searchParameter === "phoneNo") {
      newValue = newValue.trim(" ");
      if (newValue === "0" || newValue.length >= 15) {
        return true;
      } else {
        setValue(newValue);
        if (newValue) {
          if (newValue.length >= 3) {
            handleSearchRedirect(newValue);
          }
        }
      }
    } else {
      setValue(newValue);
      if (newValue) {
        newValue = newValue.trim(" ");
        if (newValue.length >= 3) {
          handleSearchRedirect(newValue);
        }
      }
    }
  };
  const onClick = (event) => {
    let value = event.target.value;
    if (event.key === "Enter") {
      setValue(value);
      handleSearchRedirect(value);
      handlePolicyOpen();
    }
  };

  const handlePolicyOpen = () => {
    if (count === 1) {
      if (data[0]["policyNo"] && url !== "claim/csr") {
        let policyNumber = data[0]["policyNo"];
        window.open("/#/app/policy-view/" + policyNumber, "_blank");
      } else {
        let claimNumber = data[0]["claimNo"];
        let policyNumber = data[0]["policyNo"];
        window.open(
          "/#/app/claims-view/" + claimNumber + "/" + policyNumber,
          "_blank",
        );
      }
    }
  };
  const handleSearchRedirect = (paramterValue) => {
    props.history.push({
      pathname: "/app/search-results",
    });
  };

  const onSuggestionsFetchRequested = ({ value }) => {
    let filterList = [];
    // handleSearchRedirect(value);
    switch (searchParameter) {
      case "insuredName":
        data.forEach((element) => {
          filterList.push({
            name: element.ins1FullName,
          });
        });
        break;
      case "policyNo":
        data.forEach((element) => {
          filterList.push({
            name: element.policyNo,
          });
        });
        break;
      case "licenseNo":
        data.forEach((element) => {
          filterList.push({
            name: element.licenseNo,
          });
        });
        break;
      case "vin":
        data.forEach((element) => {
          filterList.push({
            name: element.vin,
          });
        });
        break;
      default:
        break;
    }
  };

  const onSuggestionsClearRequested = () => {
    // setSuggestions([]);
  };

  const inputProps = {
    disabled: hasPermission(["POLICY CSR"]) && hasPermission(["CLAIMS CSR"]),
    placeholder:
      searchParameter === "policyNo"
        ? "Enter Policy Number"
        : searchParameter === "insuredName"
        ? "Enter Insured Name"
        : searchParameter === "licenseNo"
        ? "Enter License Number"
        : searchParameter === "vin"
        ? "Enter Car Vin"
        : searchParameter === "phoneNo"
        ? "Enter Phone Number"
        : searchParameter === "claimantName"
        ? "Enter Claimant Name"
        : searchParameter === "claimNO"
        ? "Enter Claim Number"
        : "Enter Claim Number",
    value,
    onChange: onChange,
    onKeyDown: onClick,
  };

  const handleChange = (event) => {
    setValueDropDown(event.target.value);
    localStorage.setItem("defaultValue", event.target.value);
    let val = event.target.value.split("-");
    let temp = searchOptions.concat(claimsOptions);
    temp.forEach((element) => {
      if (element.value === val[0] && element.url === val[1]) {
        setUrl(element.url);
        localStorage.setItem("URL", element.url);
        setSearchParameter(element.value);
        localStorage.setItem("searchElement", element.value);
        setValue("");
      }
    });
  };
  const handleSearchClick = () => {
    let val = value.trim("");
    if (val) {
      handleSearchRedirect(val);
      handlePolicyOpen();
    }
  };
  const handleClickMenu = (e) => {
    setBgFlag(true);
    if (localStorage.getItem("AUTH_TOKEN")) {
      setProfileMenu(e);
    } else {
      props.history.push("/");
    }
  };
  const handleCloseMenu = () => {
    setProfileMenu(null);
    setBgFlag(false);
  };
  const theme = createMuiTheme({
    props: {
      MuiSelect: {
        MenuProps: {
          getContentAnchorEl: null,
          anchorOrigin: {
            vertical: "bottom",
            horizontal: "left",
          },
        },
      },
    },
  });

  return (
    <AppBar position="fixed" className={classes.appBar}>
      <Toolbar className={classes.toolbar}>
        <IconButton
          color="inherit"
          onClick={() => toggleSidebar(layoutDispatch)}
          className={classNames(
            classes.headerMenuButton,
            classes.headerMenuButtonCollapse,
          )}
        >
          {layoutState.isSidebarOpened ? (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          ) : (
            <MenuIcon
              classes={{
                root: classNames(
                  classes.headerIcon,
                  classes.headerIconCollapse,
                ),
              }}
            />
          )}
        </IconButton>
        <Typography variant="h6" weight="medium" className={classes.logotype}>
          {companyName}
        </Typography>
        <div className={classes.grow} />
        <ThemeProvider theme={theme}>
          <FormControl className={classes.formControl}>
            <Select
              className={classes.selectBox}
              labelId="demo-simple-select-outlined-label"
              id="demo-simple-select-outlined"
              value={valueDropDown}
              label="searchParameter"
              name="searchParameter"
              disabled={
                hasPermission(["POLICY CSR"]) && hasPermission(["CLAIMS CSR"])
              }
              onChange={handleChange}
              classes={{
                // root: classes.dropdownColor,
                icon: classes.dropdownColor,
              }}
            >
              {!hasPermission(["POLICY CSR"]) ? (
                <MenuItem className={"search-paramter-label-section"} disabled>
                  UW
                </MenuItem>
              ) : null}
              {!hasPermission(["POLICY CSR"])
                ? searchOptions.map((option) => {
                    return (
                      <MenuItem
                        className={"search-paramter-label"}
                        key={option.id}
                        value={option.value + "-" + option.url}
                      >
                        {option.label}
                      </MenuItem>
                    );
                  })
                : null}
              {!hasPermission(["CLAIMS CSR"]) ? (
                <MenuItem className={"search-paramter-label-section"} disabled>
                  CLAIMS
                </MenuItem>
              ) : null}
              {!hasPermission(["CLAIMS CSR"])
                ? claimsOptions.map((option) => {
                    return (
                      <MenuItem
                        className={"search-paramter-label"}
                        key={option.id}
                        value={option.value + "-" + option.url}
                      >
                        {option.label}
                      </MenuItem>
                    );
                  })
                : null}
            </Select>
          </FormControl>
        </ThemeProvider>
        <div className={classes.searchBox}>
          {/* {searchParameter === "phoneNo" ? (
            <SearchPhoneWidget
              id={"phoneNo"}
              name={"phoneNo"}
              onChange={onPhoneChange}
            />
          ) : ( */}
          <Autosuggest
            suggestions={[]}
            onSuggestionsFetchRequested={onSuggestionsFetchRequested}
            onSuggestionsClearRequested={onSuggestionsClearRequested}
            getSuggestionValue={getSuggestionValue}
            renderSuggestion={renderSuggestion}
            inputProps={inputProps}
          />
          {/* )} */}
          <SearchIcon
            classes={{ root: classes.headerIcon }}
            onClick={handleSearchClick}
          />
        </div>
        <div className={classes.grow} />

        <IconButton
          aria-haspopup="true"
          color="inherit"
          className={bgFlag ? classes.iconProfile1 : classes.iconProfile}
          aria-controls="profile-menu"
          onClick={(e) => handleClickMenu(e.currentTarget)}
        >
          {localStorage.getItem("FIRSTNAME") &&
          localStorage.getItem("LASTNAME") ? (
            <span className={bgFlag ? "profile-icon1" : "profile-icon"}>
              {localStorage.getItem("FIRSTNAME").split("")[0].toUpperCase() +
                localStorage.getItem("LASTNAME").split("")[0].toUpperCase()}
            </span>
          ) : null}
        </IconButton>

        <Menu
          id="mail-menu"
          open={Boolean(mailMenu)}
          anchorEl={mailMenu}
          onClose={() => setMailMenu(null)}
          MenuListProps={{ className: classes.headerMenuList }}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <div className={classes.profileMenuUser}>
            <Typography variant="h4" weight="medium">
              New Messages
            </Typography>
            <Typography
              className={classes.profileMenuLink}
              component="a"
              color="secondary"
            >
              {messages.length} New Messages
            </Typography>
          </div>
          {messages.map((message) => (
            <MenuItem key={message.id} className={classes.messageNotification}>
              <div className={classes.messageNotificationSide}>
                <UserAvatar color={message.variant} name={message.name} />
                <Typography size="sm" color="text" colorBrightness="secondary">
                  {message.time}
                </Typography>
              </div>
              <div
                className={classNames(
                  classes.messageNotificationSide,
                  classes.messageNotificationBodySide,
                )}
              >
                <Typography weight="medium" gutterBottom>
                  {message.name}
                </Typography>
                <Typography color="text" colorBrightness="secondary">
                  {message.message}
                </Typography>
              </div>
            </MenuItem>
          ))}
          <Fab
            variant="extended"
            color="primary"
            aria-label="Add"
            className={classes.sendMessageButton}
          >
            Send New Message
            <SendIcon className={classes.sendButtonIcon} />
          </Fab>
        </Menu>
        <Menu
          id="notifications-menu"
          open={Boolean(notificationsMenu)}
          anchorEl={notificationsMenu}
          onClose={() => setNotificationsMenu(null)}
          className={classes.headerMenu}
          disableAutoFocusItem
        >
          <div className={classes.notificationshow}>
            <span className={classes.notificationnos}>
              Notification ({notifications.length})
            </span>
            <span className={classes.viewAll}>View All</span>
          </div>
          {notifications.map((notification) => (
            <MenuItem
              key={notification.id}
              onClick={() => setNotificationsMenu(null)}
              // className={classes.headerMenuItem,classes.notificationbox}
              className={classNames(
                classes.headerMenuItem,
                classes.notificationbox,
              )}
            >
              {/* <Notification {...notification} /> */}
            </MenuItem>
          ))}
        </Menu>
        <Menu
          id="profile-menu"
          open={Boolean(profileMenu)}
          anchorEl={profileMenu}
          onClose={() => handleCloseMenu(null)}
          className={classes.headerMenu}
          classes={{ paper: classes.profileMenu }}
          disableAutoFocusItem
        >
          <Link to="/app/myaccount" className="no-underline">
            <MenuItem
              className={classNames(
                classes.profileMenuItem,
                classes.headerMenuItem,
              )}
              onClick={() => setProfileMenu(null)}
            >
              <PermIdentityOutlinedIcon className={classes.profileMenuIcon} />{" "}
              My Account
            </MenuItem>
          </Link>

          <MenuItem
            className={classNames(
              classes.profileMenuItem,
              classes.headerMenuItem,
            )}
            onClick={() => signOut(userDispatch, props.history)}
          >
            <ExitToAppOutlinedIcon className={classes.profileMenuIcon} /> Logout
          </MenuItem>
        </Menu>
      </Toolbar>
    </AppBar>
  );
}
